/**
 * Handle type of reading for rtuevo
 */
export enum RtuevoReadingType {
    MAIN_DATA = 1,
    DATAPOINTS = 2
}